
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elections/[stateElection]/constituencies/[constituency]",
      function () {
        return require("private-next-pages/elections/[stateElection]/constituencies/[constituency].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elections/[stateElection]/constituencies/[constituency]"])
      });
    }
  